import React from "react";
import BellIcon from "../../images/bellIcon.svg";
import NextLogo from "../../images/edetail-NextLogo.svg";
import NCCABanner from "../../images/NCCA-Banner.svg";
import NCCAModule from "../../images/NCCA-Module.svg";
import NCCAEmail from "../../images/NCCA-Email.svg";
import NCCAEdetail from "../../images/NCCA-e-Detail.svg";
import dashboarLogo from "../../images/9DOT.svg";
import activeDashboardLogo from "../../images/active9Dot.svg";
import "../../css/TemplateManger.scss";

const TemplateHeader = (props) => {
  const { openNCCAModalHandler, isOpenNCCAModal } = props;

  const NCCAHandler = (type) => {
    window.open(
      `https://ncca${type}-gilead-${process.env.REACT_APP_NOT_SECRET_CODE}.indegene.com/`
    );
  };

  return (
    <div className="logoBlock" style={{ position: "relative" }}>
      <div className="d-flex">
        <div className="" onClick={openNCCAModalHandler}>
          <img
            src={isOpenNCCAModal ? activeDashboardLogo : dashboarLogo}
            alt="NCCA apps"
            title="NCCA apps"
            className="img-fluid nine-dot-img"
          />
        </div>
        <div>
          <img
            src={NextLogo}
            alt=""
            className="img-fluid nextLogoCss nextLogoSTyle"
          />
        </div>
      </div>
      {isOpenNCCAModal && (
        <div className="ncca-popup-modal">
          <ul>
            <li onClick={() => NCCAHandler("module")}>
              <span className="ncca-list">
                <img src={NCCAModule} width={14} height={16} />
                <span>NCCA Module</span>
              </span>
            </li>
            <li onClick={() => NCCAHandler("email")}>
              <span className="ncca-list">
                <img src={NCCAEmail} width={16} height={14} />
                <span>NCCA Email</span>
              </span>
            </li>
            {/* <li>
              <span className="ncca-list">
                <img src={NCCAEdetail} width={16} height={12} />
                <span className="active-gilead">NCCA e-Detail</span>
              </span>
            </li> */}
            <li onClick={() => NCCAHandler("banner")}>
              <span className="ncca-list">
                <img src={NCCABanner} width={16} height={13} />
                <span>NCCA Banner</span>
              </span>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default TemplateHeader;
